import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/Users/rafaelosorio/Documents/GitHub/tech-academy-apac/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const AnchorLinks = makeShortcode("AnchorLinks");
const AnchorLink = makeShortcode("AnchorLink");
const Accordion = makeShortcode("Accordion");
const AccordionItem = makeShortcode("AccordionItem");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <AnchorLinks mdxType="AnchorLinks">
  <AnchorLink mdxType="AnchorLink">GitOps Lab - Team Environments</AnchorLink>
  <AnchorLink mdxType="AnchorLink">GitOps Lab - Backup Environments</AnchorLink>
  <AnchorLink mdxType="AnchorLink">End-to-End Labs - Team Environments</AnchorLink>
  <AnchorLink mdxType="AnchorLink">End-to-End Labs - Backup Environments</AnchorLink>
    </AnchorLinks>
    <hr></hr>
    <h2>{`GitOps Lab - Team Environments`}</h2>
    <p>{`For the GitOps session, each team will receive a pre-installed ROKS cluster with GitOps Configuration and a pre-created GitHub Organization. Based in your team number, check the details below.`}</p>
    <p><strong parentName="p">{`Notes:`}</strong>{`
The instructor must add the team members to the ROKS cluster before you can access the cluster, OCP Console and GitHub Organization. You will have Cluster admin permissions.`}</p>
    <hr></hr>
    <h2>{`GitOps Lab - Backup Environments`}</h2>
    <hr></hr>
    <h2>{`End-to-End Labs - Team Environments`}</h2>
    <p>{`For the End-to-End labs, each team will receive a pre-installed ROKS cluster with CP4i installed and configured. Based in your team number, check the details below.`}</p>
    <p><strong parentName="p">{`Notes:`}</strong>{`
The instructor must add the team members to the ROKS cluster before you can access the cluster, OCP Console and CP4I. You will have Cluster admin permissions.`}</p>
    <Accordion mdxType="Accordion">
      <AccordionItem title="Team 01" mdxType="AccordionItem">
        <p><strong parentName="p">{`Cluster:`}</strong>{` `}<a href="https://cloud.ibm.com/kubernetes/clusters/cclludhw0b1qupjgc7kg/overview?platformType=openshift" target="_blank">{`cp4i-apac-multi01`}</a></p>
      </AccordionItem>
      <AccordionItem title="Team 02" mdxType="AccordionItem">
        <p><strong parentName="p">{`Cluster:`}</strong>{` `}<a href="https://cloud.ibm.com/kubernetes/clusters/ccklv5is0lbbgu468uv0/overview?platformType=openshift" target="_blank">{`cp4i-apac-multi02`}</a></p>
      </AccordionItem>
      <AccordionItem title="Team 03" mdxType="AccordionItem">
        <p><strong parentName="p">{`Cluster:`}</strong>{` `}<a href="https://cloud.ibm.com/kubernetes/clusters/cclhso5s03scbmbqo91g/overview?platformType=openshift" target="_blank">{`cp4i-apac-multi03`}</a></p>
      </AccordionItem>
      <AccordionItem title="Team 04" mdxType="AccordionItem">
        <p><strong parentName="p">{`Cluster:`}</strong>{` `}<a href="https://cloud.ibm.com/kubernetes/clusters/cclhsr8s0im3kiu77i4g/overview?platformType=openshift" target="_blank">{`cp4i-apac-multi04`}</a></p>
      </AccordionItem>
      <AccordionItem title="Team 05" mdxType="AccordionItem">
        <p><strong parentName="p">{`Cluster:`}</strong>{` `}<a href="https://cloud.ibm.com/kubernetes/clusters/cclkc7ct035np0maudf0/overview?platformType=openshift" target="_blank">{`cp4i-apac-multi05`}</a></p>
      </AccordionItem>
      <AccordionItem title="Team 06" mdxType="AccordionItem">
        <p><strong parentName="p">{`Cluster:`}</strong>{` `}<a href="https://cloud.ibm.com/kubernetes/clusters/ccllqf2w0l663vr75f50/overview?platformType=openshift" target="_blank">{`cp4i-apac-multi06`}</a></p>
      </AccordionItem>
      <AccordionItem title="Team 07" mdxType="AccordionItem">
        <p><strong parentName="p">{`Cluster:`}</strong>{` `}<a href="https://cloud.ibm.com/kubernetes/clusters/cclhsurs024ps5v023i0/overview?platformType=openshift" target="_blank">{`cp4i-apac-multi07`}</a></p>
      </AccordionItem>
      <AccordionItem title="Team 09" mdxType="AccordionItem">
        <p><strong parentName="p">{`Cluster:`}</strong>{` `}<a href="https://cloud.ibm.com/kubernetes/clusters/cclht57s0kno06677i50/overview?platformType=openshift" target="_blank">{`cp4i-apac-multi09`}</a></p>
      </AccordionItem>
      <AccordionItem title="Team 10" mdxType="AccordionItem">
        <p><strong parentName="p">{`Cluster:`}</strong>{` `}<a href="https://cloud.ibm.com/kubernetes/clusters/cclht84s0qrptnjqo920/overview?platformType=openshift" target="_blank">{`cp4i-apac-multi10`}</a></p>
      </AccordionItem>
      <AccordionItem title="Team 11" mdxType="AccordionItem">
        <p><strong parentName="p">{`Cluster:`}</strong>{` `}<a href="https://cloud.ibm.com/kubernetes/clusters/cclhtbas09k5qgum5140/overview?platformType=openshift" target="_blank">{`cp4i-apac-multi11`}</a></p>
      </AccordionItem>
      <AccordionItem title="Team 13" mdxType="AccordionItem">
        <p><strong parentName="p">{`Cluster:`}</strong>{` `}<a href="https://cloud.ibm.com/kubernetes/clusters/cclhthrs03j97sv023ig/overview?platformType=openshift" target="_blank">{`cp4i-apac-multi13`}</a></p>
      </AccordionItem>
      <AccordionItem title="Team 14" mdxType="AccordionItem">
        <p><strong parentName="p">{`Cluster:`}</strong>{` `}<a href="https://cloud.ibm.com/kubernetes/clusters/cclhtl5s0gv3e85i1200/overview?platformType=openshift" target="_blank">{`cp4i-apac-multi14`}</a></p>
      </AccordionItem>
      <AccordionItem title="Team 15" mdxType="AccordionItem">
        <p><strong parentName="p">{`Cluster:`}</strong>{` `}<a href="https://cloud.ibm.com/kubernetes/clusters/ccl4hqnw0p1gmcas6990/overview?platformType=openshift" target="_blank">{`cp4i-apac-multi15`}</a></p>
      </AccordionItem>
      <AccordionItem title="Team 16" mdxType="AccordionItem">
        <p><strong parentName="p">{`Cluster:`}</strong>{` `}<a href="https://cloud.ibm.com/kubernetes/clusters/ccl4htjw058pboasag5g/overview?platformType=openshift" target="_blank">{`cp4i-apac-multi16`}</a></p>
      </AccordionItem>
      <AccordionItem title="Team 17" mdxType="AccordionItem">
        <p><strong parentName="p">{`Cluster:`}</strong>{` `}<a href="https://cloud.ibm.com/kubernetes/clusters/ccl4i0cw0gcut7bjk5bg/overview?platformType=openshift" target="_blank">{`cp4i-apac-multi17`}</a></p>
      </AccordionItem>
      <AccordionItem title="Team 18" mdxType="AccordionItem">
        <p><strong parentName="p">{`Cluster:`}</strong>{` `}<a href="https://cloud.ibm.com/kubernetes/clusters/ccl4i2jw00meemqsag60/overview?platformType=openshift" target="_blank">{`cp4i-apac-multi18`}</a></p>
      </AccordionItem>
      <AccordionItem title="Team 19" mdxType="AccordionItem">
        <p><strong parentName="p">{`Cluster:`}</strong>{` `}<a href="https://cloud.ibm.com/kubernetes/clusters/ccl4i56w0mvbt3f8e390/overview?platformType=openshift" target="_blank">{`cp4i-apac-multi19`}</a></p>
      </AccordionItem>
      <AccordionItem title="Team 20" mdxType="AccordionItem">
        <p><strong parentName="p">{`Cluster:`}</strong>{` `}<a href="https://cloud.ibm.com/kubernetes/clusters/cclj1ivd03ddogbjnrd0/overview?platformType=openshift" target="_blank">{`cp4i-apac-multi20`}</a></p>
      </AccordionItem>
      <AccordionItem title="Team 21" mdxType="AccordionItem">
        <p><strong parentName="p">{`Cluster:`}</strong>{` `}<a href="https://cloud.ibm.com/kubernetes/clusters/cclj1bld0b5bskjjnrcg/overview?platformType=openshift" target="_blank">{`cp4i-apac-multi21`}</a></p>
      </AccordionItem>
      <AccordionItem title="Team 22" mdxType="AccordionItem">
        <p><strong parentName="p">{`Cluster:`}</strong>{` `}<a href="https://cloud.ibm.com/kubernetes/clusters/cclj1o6d00i9qj7sgdfg/overview?platformType=openshift" target="_blank">{`cp4i-apac-multi22`}</a></p>
      </AccordionItem>
      <AccordionItem title="Team 23" mdxType="AccordionItem">
        <p><strong parentName="p">{`Cluster:`}</strong>{` `}<a href="https://cloud.ibm.com/kubernetes/clusters/cclj1dnd014k8ifqast0/overview?platformType=openshift" target="_blank">{`cp4i-apac-multi23`}</a></p>
      </AccordionItem>
      <AccordionItem title="Team 25" mdxType="AccordionItem">
        <p><strong parentName="p">{`Cluster:`}</strong>{` `}<a href="https://cloud.ibm.com/kubernetes/clusters/cclj1qmd0vaqlnbrb2kg/overview?platformType=openshift" target="_blank">{`cp4i-apac-multi25`}</a></p>
      </AccordionItem>
    </Accordion>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      